import { render, staticRenderFns } from "./DeleteActionModal.vue?vue&type=template&id=3c6b3317&scoped=true&class=fill-height&"
import script from "./DeleteActionModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteActionModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteActionModal.vue?vue&type=style&index=0&id=3c6b3317&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b3317",
  null
  
)

export default component.exports